<template>
    <div class="premium-tooltip-wrapper">
        <slot />

        <span v-if="show" class="premium-tooltip">
            {{ $t('modals.make_direct_referal_modal.inivte_billing.subscribe_to_premium') }}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            show: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .premium-tooltip-wrapper {
        position: relative;
        display: inline-block;
    }

    .premium-tooltip {
        visibility: hidden;
        opacity: 0;
        position: absolute;
        bottom: 120%;
        left: 50%;
        transform: translateX(-50%);
        background-color: $color--accent-1;
        color: #fff;
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 12px;
        white-space: nowrap;
        transition: opacity 0.2s ease;
        z-index: 100;
    }

    .premium-tooltip-wrapper:hover .premium-tooltip {
        visibility: visible;
        opacity: 1;
    }
</style>
